import posthog from 'posthog-js';

type FeatureClickProperties = Record<string, string | number | boolean | null | undefined>;

const FeatureTrackingService = {
  captureFeatureClick(featureName: string, properties: FeatureClickProperties = {}) {
    if (typeof window === 'undefined' || !posthog?.capture) {
      return;
    }

    posthog.capture('feature_click', {
      feature_name: featureName,
      interaction_type: 'click',
      ...properties,
    });
  },
};

export default FeatureTrackingService;
